import { serviceOnVacationHoldDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getserviceOnVacationHoldEn = () => {
  const data = serviceOnVacationHoldDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addserviceOnVacationHold = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-put-my-service-on-a-seasonal-or-vacation-hold`,
    ) &&
    document.getElementById(`serviceOnVacationHoldJSONLD`) === null
  ) {
    const script = serviceOnVacationHoldJSONLDEn()
    addJSONLDToHead(script, `serviceOnVacationHoldJSONLD`)
  } else {
    removeElement(`serviceOnVacationHoldJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const serviceOnVacationHoldJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getserviceOnVacationHoldEn(),
  }
  return FaqBagsterTemplate
}
